






























import { Component, Prop, Vue } from 'vue-property-decorator'
import PhilosophyInfo from '@/components/PhilosophyInfo.vue'
import HowToWalk from '@/components/HowToWalk.vue'
import EventInfo from '@/components/EventInfo.vue'

@Component({
  components: {
    PhilosophyInfo,
    HowToWalk,
    EventInfo
  }
})
export default class DetailInfoModal extends Vue {
  dialog: boolean = false
  notifications: Boolean = false
  contentTitle: String = 'test'
  contentImage: String = ''
  contentDetailText: String = ''

  @Prop()
  contentId!: string

  created() {
    var contentData = require('@/contents/content_' + this.contentId + '.json')
    this.contentTitle = contentData.contentTitle
    // this.contentImage = contentData.contentImage
    // this.contentDetailText = contentData.contentDetailText
  }
}
